<template>
  <section>
    <job-publish-section-title :title="title" />
    <table class="unstriped hover boss-table">
      <thead>
        <slot name="head" />
      </thead>
      <tbody>
        <template v-for="(object, i) in renderingObjects">
          <component
            :is="componentName"
            :key="i"
            :job="object"
            :option="object"
            :is-publishing="false"
          />
        </template>
        <infinite-loading
          v-if="!isClosed"
          @infinite="infiniteHandler"
        >
          <div slot="no-more" />
          <div slot="no-results" />
        </infinite-loading>
      </tbody>
    </table>
    <div
      v-if="isExistsMoreObjects"
      class="text-center"
      :class="{'pega-past-more-close-button': !isClosed}"
      data-test="button"
    >
      <button
        class="boss-button-center boss-button-large margin-top-1 margin-bottom-1"
        data-test="more-close-button"
        @click="isClosed = !isClosed"
      >
        {{ isClosed ? 'もっと見る' : '閉じる' }}
      </button>
    </div>
  </section>
</template>

<script>
import JobPublishSectionTitle from '@/components/molecules/JobPublishSectionTitle'
import JobPublishedJob from '@/components/molecules/JobPublishedJob'
import JobPublishedOption from '@/components/molecules/JobPublishedOption'
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import _ from 'lodash'

export default {
  components: {
    JobPublishSectionTitle,
    JobPublishedJob,
    JobPublishedOption,
    InfiniteLoading
  },
  props: {
    title: {
      type: String,
      required: true
    },
    // JobPublishedJob or JobPublishedOptionが渡される
    componentName: {
      type: String,
      required: true
    },
    recentPastObjects: {
      type: Array,
      required: true
    },
    pastObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isClosed: true,
      infinityObjects: []
    }
  },
  computed: {
    renderingObjects () {
      return this.isClosed ? this.recentPastObjects : this.infinityObjects
    },
    isExistsMoreObjects () {
      return !_.isEqual(this.recentPastObjects, this.pastObjects)
    }
  },
  watch: {
    pastObjects (val) {
      this.initialInfinityScrollIterator(val)
    }
  },
  methods: {
    initialInfinityScrollIterator (val) {
      this.infinityObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(val, 50)
      this.infinityObjects.push(...this.infinityScrollIterator.next().value)
    },
    infiniteHandler ($state) {
      if (this.infinityScrollIterator) {
        const next = this.infinityScrollIterator.next()
        if (next.done) {
          $state.complete()
        } else {
          this.infinityObjects.push(...next.value)
          $state.loaded()
        }
      }
    }
  }
}
</script>
